import React from 'react'
import PropTypes from 'prop-types'

const EndPollIcon = (props) => {
  const { color = '#183560', classes = 'w-20' } = props
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z"
        fill={color}
      />
      <path
        d="M17.0002 12.1992C14.3542 12.1992 12.2002 14.3532 12.2002 16.9992C12.2002 19.6452 14.3542 21.7992 17.0002 21.7992C19.6462 21.7992 21.8002 19.6452 21.8002 16.9992C21.8002 14.3532 19.6462 12.1992 17.0002 12.1992ZM15.8002 19.9992L13.4002 17.5992L14.2462 16.7532L15.8002 18.3012L19.7542 14.3472L20.6002 15.1992L15.8002 19.9992Z"
        fill="#22C55E"
      />
      <path
        d="M17 11C13.688 11 11 13.688 11 17C11 20.312 13.688 23 17 23C20.312 23 23 20.312 23 17C23 13.688 20.312 11 17 11ZM17 21.8C14.354 21.8 12.2 19.646 12.2 17C12.2 14.354 14.354 12.2 17 12.2C19.646 12.2 21.8 14.354 21.8 17C21.8 19.646 19.646 21.8 17 21.8ZM19.754 14.348L15.8 18.302L14.246 16.754L13.4 17.6L15.8 20L20.6 15.2L19.754 14.348Z"
        fill="#FAFDFF"
      />
    </svg>
  )
}

EndPollIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(EndPollIcon)
